import { useEffect, useState } from 'react';
import classNames from 'classnames';
import {
  ChoiceGroup as CChoiceGroup,
  ChoiceGroupPropOnChange,
} from '@consta/uikit/ChoiceGroup';
import { toggleZoomMode } from '@/widgets/storage-viewer/model';

export const ChoiceGroup = ({
  items,
  value,
  onChange,
  className = '',
}: {
  items: Choice[];
  value: Choice;
  onChange?: (item: Choice) => void;
  className?: string;
}) => {
  // Используем значение по умолчанию для предотвращения undefined
  const [_value, setValue] = useState<Choice | null>(items[0]);

  // Синхронизируем внутреннее состояние с внешним значением
  useEffect(() => {
    setValue(value);
  }, [value]);

  const onItemChange: ChoiceGroupPropOnChange<Choice, false> = ({ value }) => {
    setValue(value);
    onChange?.(value); // Добавляем проверку на существование функции
    if (value === items[1]) {
      toggleZoomMode?.(false);
    }
  };

  return (
    <CChoiceGroup
      className={classNames(className)}
      value={_value}
      onChange={onItemChange}
      items={items}
      getItemLabel={(item) => item.label}
      multiple={false}
      name="ChoiceGroup"
    />
  );
};

export type Choice = {
  value: string;
  label: string;
};
